<script>
  export default {
    props: {
      state: Number,
      time: String,
      background: {
        type: Boolean,
        default: false
      }
    },
    render: function (createElement) { 
      /*
      <div class="sc-message--state">
        <div class="inner">
          <span class="time">{{time}}</span>
          <div class="state" v-if="sent">
            <StateIcon state="state"></StateIcon>
          </div>
        </div>
      </div>
      */
      let $state = null

      if (this.state) {
        let color = ''
        let icon = ''
        if (this.state == this.states.MessageSent) {
          color = 'gray--text'; icon = 'done'
        } else if (this.state == this.states.MessageFailed) {
          color = 'red--text'; icon = 'error_outline'
        }else if (this.state == this.states.MessageDelivered) {
          color = 'gray--text'; icon = 'done_all'
        } else if (this.state == this.states.MessageRead) {
          color = 'red--text'; icon = 'done_all'
        } 

        const attr = {
          class: 'v-icon material-icons ' + color,
          style:'font-size: 15px;',
          attrs: {
            'aria-hidden': true
          }
        }
        $state = createElement('div', { class: 'state' }, [
          createElement('i', attr, icon) 
        ])
      }

      let $time = createElement('div', { 
        class: 'time', 
        style: {
          color: this.background ? 'var(--v-secondary-lighten3)' : 'var(--secondary-text)'
        }
      }, this.time)

      return createElement('div', { 
        class: [
          'sc-message--state', 
          this.background ? 'sc-message--state-bkground' : null
        ]
      }, [
        createElement('div', { class: 'inner'}, [$time, $state])
      ])
    }
  }
</script>

<style>
  .sc-message--state {
    float: right;
    margin: -15px -5px -5px 4px;
    position: relative;
    padding:1px 2px;
  }
  .sc-message--state-bkground {
    background-color: rgba(0,0,0, 0.25);
    border-radius: 5px;
    color: var(--v-secondary-lighten3);
  }

  .sc-message--state .inner {
    font-size: 11px;
    font-weight: 300;
    height: 15px;
    line-height: 15px;
    white-space: nowrap;
  }

  .sc-message--state .time {
    vertical-align: bottom;
    display: inline-block;
  }

  .sc-message--state .state {
    margin-left: 2px;
    display: inline-block;
  }
</style>